import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChildren,
  QueryList,
  ElementRef,
  AfterViewInit,
} from '@angular/core';

@Component({
  selector: 'myclubrewards-rewards-tablet',
  templateUrl: './rewards-tablet.component.html',
  styleUrls: ['./rewards-tablet.component.scss'],
})
export class RewardsTabletComponent implements OnInit, OnDestroy {
  @Input() rewards: any;

  @ViewChildren('expansionPanel')
  private expansionPanels: QueryList<ElementRef>;

  constructor(private renderer2: Renderer2) {}

  ngOnInit() {}

  ngOnDestroy() {}

  isArray(data: any) {
    return Array.isArray(data);
  }

  expandPanel(evt: any, expansionPanel: any) {
    const element = this.expansionPanels.find(
      (item) => item.nativeElement === expansionPanel
    );

    if (!element.nativeElement.classList.contains('expand-div')) {
      this.renderer2.removeClass(element.nativeElement, 'collapse-div');
      this.renderer2.addClass(element.nativeElement, 'expand-div');
      evt.target.innerHTML = 'SHOW LESS';
    } else {
      this.renderer2.removeClass(element.nativeElement, 'expand-div');
      this.renderer2.addClass(element.nativeElement, 'collapse-div');
      evt.target.innerHTML = 'LEARN MORE';
    }
  }

  /**
   * Add bonus percentage to the text
   * @param {any} textData 
   * @param {any} percentage 
   */
  getChangedString(textData: any, percentage: any) {
    if (percentage && percentage !== 'N/A') {
      return textData.replace('bonus', percentage + ' bonus');
    }
    return textData;
  }
}
